module.exports = __webpack_public_path__ + "img/bonus-code.ed2c8d6b.svg";